export enum PaymentRequestTrackerName {
  Month = "Month",
  SchoolYear = "SchoolYear",
  StudentData = "StudentData",
  SchoolCarrierData = "SchoolCarrierData",
  AuthorizedCarrierData = "AuthorizedCarrierData"
}

export default PaymentRequestTrackerName;
